<template>
    <div class="social">
      <div class="facebook">
	    <a :href="`${data.facebook}`" target="_blank"><img src="../../assets/img/facebook.png" alt="Facebook"/></a>
	  </div>
      <div class="twitter">
	    <a :href="`${data.twitter}`" target="_blank"><img src="../../assets/img/twitter.png" alt="Twitter"/></a>
	  </div>
      <div class="instagram">
	    <a :href="`${data.instagram}`" target="_blank"><img src="../../assets/img/instagram.png" alt="Instagram"/></a>
	  </div>
      <div class="linkedin">
	    <a :href="`${data.linkedin}`" target="_blank"><img src="../../assets/img/linkedin.png" alt="LinkedIn"/></a>
	  </div>
	  <div class="clear"></div>
    </div>
</template>

<script>
    import data from '../../assets/data'

    export default {
      name: 'Social',
      data: () => {
        return {
          data
        }
      },     
      props: {
        msg: String
      }
    }
</script>

<style scoped>
</style>
